import axios from 'axios';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { RestApiState } from '../../interfaces/Rest/types';


export interface AcbOsProps {
    file?: string;
    file_name?: string;
    file_hash?: string;
}

export interface AcbOsPostProps {
    file: File;
}


export const fetchOsData = (serialNumber:string, role: string, setData: (value:any) => void):void => {
    axios.get<AcbOsProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/update-remote-controller`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: AcbOsProps = response.data
            setData(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });

}


export const updateOsData = (serialNumber: string, role: string, data: any, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<AcbOsPostProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/update-remote-controller`, data , headers)
        .then(response => {
                if (response.status === 201) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}